import AdSenseBanner from "@/components/AdSenseBanner";
import { useEffect, useState } from "react";
import SectionHeader from "@/components/SectionHeader";
import ServerCard from "@/components/ServerCard";
import IPPill from "@/components/IPPill";
import AdSenseServerCard from "@/components/AdSenseServerCard";
import { fetchServers } from "@/lib/api";

export default function Servers() {
  const [servers, setServers] = useState([]);

  useEffect(() => {
    fetchServers()
      .then(setServers)
      .catch((error) => {
        console.error("Failed to fetch servers:", error);
      });
  }, []);

  return (
    <div
      className="pt-32 pb-24 px-4 sm:px-6"
      data-testid="page-servers"
    >
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          eyebrow="Servers"
          title="Choose Your World"
          subtitle="Every server on the LostDC Network is built with unique mechanics, custom systems and dedicated moderation."
        />

        <div className="mb-10">
          <IPPill />
        </div>

        {/* Server Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {servers.map((s, i) => (
            <ServerCard
              key={s.id ?? s.key}
              server={s}
              index={i}
            />
          ))}
        </div>

        {/* How to Join + AdSense */}
        <div className="mt-20">
          <SectionHeader
            eyebrow="Getting Started"
            title="How to Join"
            subtitle="Follow the connection steps for your chosen server and start playing."
          />

          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch">
            {servers.map((s) => (
              <div
                key={s.key ?? s.id}
                className="rounded-2xl glass p-6 border border-white/10 flex flex-col"
                data-testid={`server-howto-${s.key ?? s.id}`}
              >
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#FFBF00]">
                  How to Join
                </div>

                <div className="font-hero text-2xl mt-2">
                  {s.name}
                </div>

                <ol className="mt-4 space-y-2 text-sm text-white/70 list-decimal list-inside">
                  {(s.connection_steps || []).map((step, idx) => (
                    <li key={idx}>{step}</li>
                  ))}
                </ol>
              </div>
            ))}

            {/* Ad card */}
            <AdSenseServerCard />
          </div>
        </div>

        {/* Bottom AdSense Banner - Same as Home Page */}
        <div className="mt-20">
          <AdSenseBanner />
        </div>
      </div>
    </div>
  );
}